// copied from https://github.com/MercuryTechnologies/mercury-web/blob/e4cda70f20b4ba9a8bf2d111b3e6834f2a8b9fa4/src/pages/Treasury/utils.ts
export const BPSToPercent = (bps: number) => {
  return bps / 100
}
